import DataTableAction from "components/DataTableRow/dataTableAction";
import DataTableContent from "components/DataTableRow/dataTableContent";
import { useState } from "react";
import { SUPER_ADMIN_ROLE, roleFonction } from "constant/role";

import { tableCellTextFormat } from "utils/textOperation";

export default function useTableUser() {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [actionOption, setActionOption] = useState("");

  const tableColumns = [
    { Header: "code", accessor: "code", align: "center" },
    { Header: "nom", accessor: "nom", align: "center" },
    { Header: "telephone", accessor: "telephone", align: "center" },
    { Header: "profil", accessor: "profil", align: "center" },
    { Header: "fonction", accessor: "fonction", align: "center" },
    { Header: "Sous-Préfecture", accessor: "commune", align: "center" },
    {
      Header: "Préfecture",
      accessor: "departement",
      align: "center",
    },
    { Header: "region", accessor: "region", align: "center" },
  ];
  const tableRows = (item, niveau) => {
    let rolesArr = [];
    let fonction = "";
    if (item?.roles?.length > 0) {
      rolesArr = item.roles
        .filter((i) => i.roleName !== SUPER_ADMIN_ROLE)
        .map((x) => {
          const fonctionData = roleFonction.find((y) => y.role === x.roleName);
          return fonctionData ?? x;
        });
      const sortedRoles = rolesArr
        .sort((a, b) => a.niveau - b.niveau)
        .map((x) => {
          return x?.fonction ?? x.roleName;
        });

      if (sortedRoles.length > 2) {
        fonction = `${sortedRoles.slice(0, 2).join(", ")} ...`;
      } else {
        fonction = sortedRoles.join(", ");
      }
    } else {
      fonction = "Aucun role";
    }
    let affectation = "";
    if (niveau === "1") {
      affectation = "Côte D'Ivoire";
    } else if (niveau === "2") {
      affectation = item?.lieu?.region ?? "";
    } else if (niveau === "3") {
      affectation = item?.lieu?.departement ?? "";
    } else {
      affectation = item?.lieu?.commune ?? "";
    }
    const userName = `${item?.prenom ?? ""} ${item.nom ?? ""}`;
    const row = {
      code: <DataTableContent title1={tableCellTextFormat(item?.matricul, 15)} />,
      nom: <DataTableContent title1={tableCellTextFormat(userName, 50)} />,
      telephone: <DataTableContent title2={tableCellTextFormat(item?.numTel, 15)} />,
      affectation: <DataTableContent title2={tableCellTextFormat(affectation, 15)} />,
      fonction: <DataTableContent title2={tableCellTextFormat(fonction, 50)} />,
      profil: <DataTableContent title2={tableCellTextFormat(item?.fonction, 50)} />,
      commune: <DataTableContent title2={tableCellTextFormat(item?.lieu?.commune, 50)} />,
      departement: <DataTableContent title2={tableCellTextFormat(item?.lieu?.departement, 50)} />,
      region: <DataTableContent title2={tableCellTextFormat(item?.lieu?.region, 50)} />,
    };
    return row;
  };

  const onSelectedRow = (item, action) => {
    setSelectedItem(item);
    setActionOption(action);
  };

  const renderDataTable = (listData, isShowAction, niveau) => {
    const columnsActions = [{ Header: "action", accessor: "action", align: "center" }];

    setColumns([...tableColumns, ...columnsActions]);
    if (!isShowAction) {
      setColumns(tableColumns);
    }
    const arrData = listData?.map((item) => {
      const rowData = tableRows(item, niveau);
      const actionComponent = <DataTableAction handleAction={onSelectedRow} item={item} />;

      return {
        ...rowData,
        action: actionComponent,
      };
    });

    setRows(arrData);
  };
  return {
    renderDataTable,
    rows,
    columns,
    selectedItem,
    actionOption,
    onSelectedRow,
  };
}
